import "../icon.styles.css";

const FigmaIcon = ({ width, height }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 250 250"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <g id="Frame 1">
        <path
          className="highlight"
          id="Vector"
          d="M131 84H87.2665C66.1324 84 49 65.6437 49 43C49 20.3563 66.1324 2 87.2665 2H131V84Z"
          fill="#DEF7FF"
        />
        <path
          className="shadow"
          id="Vector_2"
          d="M130.833 165.833H90C67.4483 165.833 49.1667 147.552 49.1667 125C49.1667 102.448 67.4483 84.1667 90 84.1667H130.833V165.833Z"
          fill="#B9CCD2"
        />
        <path
          className="highlight"
          id="Vector_3"
          d="M90 247.5C67.4483 247.5 49.1667 229.218 49.1667 206.667C49.1667 184.115 67.4483 165.833 90 165.833H130.833V206.667C130.833 229.218 112.552 247.5 90 247.5Z"
          fill="#DEF7FF"
        />
        <path
          className="shadow"
          id="Vector_4"
          d="M171.667 84.1667H130.833V2.5H171.667C194.218 2.5 212.5 20.7817 212.5 43.3333C212.5 65.885 194.218 84.1667 171.667 84.1667Z"
          fill="#B9CCD2"
        />
        <path
          className="highlight"
          id="Vector_5"
          d="M171.667 165.833C194.218 165.833 212.5 147.552 212.5 125C212.5 102.448 194.218 84.1667 171.667 84.1667C149.115 84.1667 130.833 102.448 130.833 125C130.833 147.552 149.115 165.833 171.667 165.833Z"
          fill="#DEF7FF"
        />
      </g>
    </svg>
  );
};

export default FigmaIcon;
